import $ from 'jquery';
import { gsap } from 'gsap';

export const animationsPimcoreSection = () => {
	const pimcoreImg = document.querySelector('.pimcore-section__img');
	const elements = ['.svg__shadow--left', '.svg__shadow--right', '.svg__text--left', '.svg__text--right', '.svg__text--middle', '.svg__circle--pink', '.svg__circle--blue', '.svg__circle--topleft', '.svg__circle--left', '.svg__circle--bottomleft', '.svg__circle--up', '.svg__circle--topright', '.svg__circle--right'];
	const animations = ['fadeInLeft', 'fadeInRight', 'fadeInLeft', 'fadeInRight', 'fadeIn', 'fadeInRight', 'fadeInLeft', 'fadeInTopLeft', 'fadeInLeft', 'fadeInBottomLeft', 'fadeInUp', 'fadeInTopRight', 'fadeInRight'];

	if (pimcoreImg) {
		const animate = (entries, observer) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					elements.forEach((item, itemIndex) => {
						animations.forEach((animation, animationIndex) => {
							if (itemIndex == animationIndex) {
								document.querySelector(item).classList.add('animate__' + animation);
							};
						});
					});
				};
			});
		};

		const observer = new IntersectionObserver(animate);
		observer.observe(pimcoreImg);
	}
};

export const animationsSolutionsPage = () => {
	const wrapper = document.querySelector('.solutions--animation');

	if (window.innerWidth >= 768 && wrapper) {
		var circles = [],
			canvas = document.querySelector('.solutions__canvas'),
			context = canvas.getContext('2d'),

			// SETTINGS 
			opacity = 0.1, // the opacity of the circles 0 to 1
			colors = ['rgba(0, 0, 0,' + opacity + ')',  // an array of rgb colors for the circles
				'rgba(255, 255, 255, 0.05)',
			],
			minSize = 10, // the minimum size of the circles in px
			maxSize = 10, // the maximum size of the circles in px
			numCircles = 120, // the number of circles
			minSpeed = -2, // the minimum speed, recommended: -maxspeed
			maxSpeed = 1,  // the maximum speed of the circles
			expandState = true; // the direction of expansion

		function buildArray() {
			'use strict';

			for (var i = 0; i < numCircles; i++) {
				var color = Math.floor(Math.random() * (colors.length - 1 + 1)) + 1,
					left = Math.floor(Math.random() * (canvas.width - 0 + 1)) + 0,
					top = Math.floor(Math.random() * (canvas.height - 0 + 1)) + 0,
					size = Math.floor(Math.random() * (maxSize - minSize + 1)) + minSize,
					leftSpeed = (Math.floor(Math.random() * (maxSpeed - minSpeed + 1)) + minSpeed) / 10,
					topSpeed = (Math.floor(Math.random() * (maxSpeed - minSpeed + 1)) + minSpeed) / 10,
					expandState = expandState;

				while (leftSpeed == 0 || topSpeed == 0) {
					leftSpeed = (Math.floor(Math.random() * (maxSpeed - minSpeed + 1)) + minSpeed) / 10,
						topSpeed = (Math.floor(Math.random() * (maxSpeed - minSpeed + 1)) + minSpeed) / 10;
				}

				var circle = { color: color, left: left, top: top, size: size, leftSpeed: leftSpeed, topSpeed: topSpeed, expandState: expandState };
				circles.push(circle);
			}
		}

		function build() {
			'use strict';

			for (var h = 0; h < circles.length; h++) {
				var curCircle = circles[h];
				context.fillStyle = colors[curCircle.color - 1];
				context.beginPath();
				if (curCircle.left > canvas.width + curCircle.size) {
					curCircle.left = 0 - curCircle.size;
					context.arc(curCircle.left, curCircle.top, curCircle.size, 0, 2 * Math.PI, false);
				} else if (curCircle.left < 0 - curCircle.size) {
					curCircle.left = canvas.width + curCircle.size;
					context.arc(curCircle.left, curCircle.top, curCircle.size, 0, 2 * Math.PI, false);
				} else {
					curCircle.left = curCircle.left + curCircle.leftSpeed;
					context.arc(curCircle.left, curCircle.top, curCircle.size, 0, 2 * Math.PI, false);
				}

				if (curCircle.top > canvas.height + curCircle.size) {
					curCircle.top = 0 - curCircle.size;
					context.arc(curCircle.left, curCircle.top, curCircle.size, 0, 2 * Math.PI, false);

				} else if (curCircle.top < 0 - curCircle.size) {
					curCircle.top = canvas.height + curCircle.size;
					context.arc(curCircle.left, curCircle.top, curCircle.size, 0, 2 * Math.PI, false);
				} else {
					curCircle.top = curCircle.top + curCircle.topSpeed;
					if (curCircle.size != maxSize && curCircle.size != minSize && curCircle.expandState == false) {
						curCircle.size = curCircle.size - 0.1;
					}
					else if (curCircle.size != maxSize && curCircle.size != minSize && curCircle.expandState == true) {
						curCircle.size = curCircle.size + 0.1;
					}
					else if (curCircle.size == maxSize && curCircle.expandState == true) {
						curCircle.expandState = false;
						curCircle.size = curCircle.size - 0.1;
					}
					else if (curCircle.size == minSize && curCircle.expandState == false) {
						curCircle.expandState = true;
						curCircle.size = curCircle.size + 0.1;
					}
					context.arc(curCircle.left, curCircle.top, curCircle.size, 0, 2 * Math.PI, false);
				}

				context.closePath();
				context.fill();
				context.ellipse;
			}
		}

		var xVal = 0;

		window.requestAnimFrame = (function (callback) {
			'use strict';
			return window.requestAnimationFrame ||
				window.webkitRequestAnimationFrame ||
				window.mozRequestAnimationFrame ||
				window.oRequestAnimationFrame ||
				window.msRequestAnimationFrame ||
				function (callback) {
					window.setTimeout(callback, 1000 / 60);
				};
		})();

		function animate() {
			'use strict';
			var canvas = document.querySelector('.solutions__canvas'),
				context = canvas.getContext('2d');

			// clear the canvas
			context.clearRect(0, 0, canvas.width, canvas.height);

			// draw the next frame
			xVal++;
			build();

			//console.log("Prep: animate ==> requestAnimFrame");
			// request a new frame
			requestAnimFrame(function () {
				animate();
			});
		}

		window.onload = function () {
			'use strict';
			canvas.width = document.querySelector('.solutions--animation').clientWidth;
			canvas.height = document.querySelector('.solutions--animation').clientHeight;
			buildArray();
			animate();
		};

		window.onresize = function () {
			'use strict';
			// console.log('resize');
			canvas.width = document.querySelector('.solutions--animation').clientWidth;
			canvas.height = document.querySelector('.solutions--animation').clientHeight;
			//buildArray();
			animate();
		};
	}
};

export const anchorSmoothScroll = () => {
	var $animateBody = $('html, body');

	$('a[href^="#"]').on('click', function (e) {
		e.preventDefault();
		$animateBody.animate({
			scrollTop: $($.attr(this, 'href')).offset().top
		}, 800);

		return false;
	});
};

export const introSectionAnimation = () => {
	if ($('.intro-section').length > 0) {
		const animationSvg = $('#intro-section-animation')

		animationDiagonal(animationSvg)
		animationBottomToRight(animationSvg)
		animationRightToTop(animationSvg)
	}
}


function animationDiagonal(animationSvg) {

	// durations for different animation parts
	const animationDuration = 40
	const animationDelayTrail = 31
	const animationDurationTrail = animationDuration / 2

	// create the timeline for the animation
	const timeline = gsap.timeline({
		repeat: -1,
		defaults: {
			ease: 'linear'
		}
	})

	// the dot that will be animated
	const dot = $('circle.diagonal-movement')

	// read the coordinates of the path (defined inside svg)
	const startX = dot.attr('cx')
	const startY = dot.attr('cy')
	const { endX, endY } = dot.data()

	// animate the dot towards the end coordinates
	timeline.to(dot[0], {
		attr: {
			'cx': endX,
			'cy': endY
		},
		duration: animationDuration
	}, 0)
	
	// create the line svg element that will serve as the trail behind the moving dot
	let trail = document.createElementNS('http://www.w3.org/2000/svg', 'line')

	// at the start it doesn't exist, so its start and end coordinates can be same
	// stroke uses a linear gradient for coloring, defined inside the svg
	$(trail).attr({
		'x1': startX,
		'y1': startY,
		'x2': startX,
		'y2': startY,
		'stroke': 'url(#diagonalTransparencyGrad)'
	})

	// append the line into a container before the dots in order for dots to have a higher z-index
	animationSvg.find('.lines-container').append(trail)

	// animate the start coordinates of the trail to follow the moving dot
	timeline.to(trail, {
		attr: {
			'x1': endX,
			'y1': endY
		},
		duration: animationDuration
	}, 0)

	// animate the end coordinates of the trail towards the end after a delay in order to start shrinking it
	timeline.to(trail, {
		attr: {
			'x2': endX,
			'y2': endY
		},
		duration: animationDurationTrail
	}, animationDelayTrail)

	/**
	 * Similar logic for creating and animating the crosshair
	 */
	let crosshairX = document.createElementNS('http://www.w3.org/2000/svg', 'line')
	let crosshairY = document.createElementNS('http://www.w3.org/2000/svg', 'line')

	$(crosshairX).attr({
		'x1': '-100%',
		'y1': startY,
		'x2': '200%',
		'y2': startY,
		'stroke': 'rgba(0,0,0,0.05)'
	})

	$(crosshairY).attr({
		'x1': startX,
		'y1': '-100%',
		'x2': startX,
		'y2': '200%',
		'stroke': 'rgba(0,0,0,0.05)'
	})

	animationSvg.find('.lines-container').prepend(crosshairX)
	animationSvg.find('.lines-container').append(crosshairY)

	timeline.to(crosshairX, {
		attr: {
			'y1': endY,
			'y2': endY
		},
		duration: animationDuration
	}, 0)

	timeline.to(crosshairY, {
		attr: {
			'x1': endX,
			'x2': endX
		},
		duration: animationDuration
	}, 0)
}


function animationBottomToRight(animationSvg) {

	// durations for different animation parts
	const animationDurationPart1 = 7
	const animationDurationPart2 = 20
	const animationDurationTrail = 27 / 4
	const animationDelayTrail = 21
	
	// create the timeline for the animation
	const timeline = gsap.timeline({
		repeat: -1,
		defaults: {
			ease: 'linear'
		}
	})
	
	// the dot that will be animated
	const dot = $('circle.bottom-to-right-movement')

	// read the coordinates of the path (defined inside svg)
	const startX = dot.attr('cx')
	const startY = dot.attr('cy')
	const { checkpointX, checkpointY, endX, endY } = dot.data()

	// animate the dot towards the checkpoint
	timeline.to(dot[0], {
		attr: {
			'cx': checkpointX,
			'cy': checkpointY
		},
		duration: animationDurationPart1
	}, 0)

	// animate the dot towards the end coordinates
	timeline.to(dot[0], {
		attr: {
			'cx': endX,
			'cy': endY
		},
		duration: animationDurationPart2
	}, animationDurationPart1)
	
	// create the line svg element that will serve as the trail behind the moving dot
	let trail = document.createElementNS('http://www.w3.org/2000/svg', 'line')

	// at the start it doesn't exist, so its start and end coordinates can be same
	// stroke uses a different linear gradient because the line is vertical
	$(trail).attr({
		'x1': startX,
		'y1': startY,
		'x2': startX,
		'y2': startY,
		'stroke': 'url(#topToBottomTransparencyGrad)'
	})
	// append the line into a container before the dots in order for dots to have a higher z-index
	animationSvg.find('.lines-container').append(trail)

	// animate the start coordinates of the trail to follow the moving dot
	timeline.to(trail, {
		attr: {
			'x1': checkpointX,
			'y1': checkpointY
		},
		duration: animationDurationPart1
	}, 0)

	// animate the opacity of the first part of the tail
	timeline.to(trail, {
		opacity: 0,
		duration: animationDurationPart1
	}, animationDurationPart1 * 2)

	// create the second line that will serve as the trail after the checkpoint
	let trail2 = document.createElementNS('http://www.w3.org/2000/svg', 'line')

	// at the start it doesn't exist, so its start and end coordinates can be same
	// stroke uses a linear gradient for coloring, defined inside the svg
	$(trail2).attr({
		'x1': checkpointX,
		'y1': checkpointY,
		'x2': checkpointX,
		'y2': checkpointY,
		'stroke': 'url(#leftToRightTransparencyGradAnimated)'
	})
	// append the line into a container before the dots in order for dots to have a higher z-index
	animationSvg.find('.lines-container').append(trail2)

	// animate the start coordinates of the second trail to follow the moving dot after the checkpoint
	timeline.to(trail2, {
		attr: {
			'x1': endX,
			'y1': endY
		},
		duration: animationDurationPart2
	}, animationDurationPart1)

	// animate the end coordinates of the first trail towards the checkpoint in order to start shrinking it
	timeline.to(trail, {
		attr: {
			'x2': checkpointX,
			'y2': checkpointY
		},
		duration: animationDurationTrail / 2
	}, animationDelayTrail)

	// animate the gradient of the second trail
	timeline.from($('#leftToRightTransparencyGradAnimated .animate')[0], {
		attr: {
			'offset': '100%'
		},
		duration: animationDurationPart2 / 2
	}, (animationDelayTrail + animationDurationTrail) * 0.7)

	// animate the end coordinates of the second trail towards the end after the first trail is gone
	timeline.to(trail2, {
		attr: {
			'x2': endX,
			'y2': endY
		},
		duration: animationDurationTrail
	}, animationDelayTrail + animationDurationTrail)

	/**
	 * Similar logic for creating and animating the crosshair
	 */
	let crosshairX = document.createElementNS('http://www.w3.org/2000/svg', 'line')
	let crosshairY = document.createElementNS('http://www.w3.org/2000/svg', 'line')

	$(crosshairX).attr({
		'x1': '-100%',
		'y1': startY,
		'x2': '200%',
		'y2': startY,
		'stroke': 'rgba(0,0,0,0.05)'
	})

	$(crosshairY).attr({
		'x1': startX,
		'y1': '-100%',
		'x2': startX,
		'y2': '200%',
		'stroke': 'rgba(0,0,0,0.05)'
	})

	animationSvg.find('.lines-container').prepend(crosshairX)
	animationSvg.find('.lines-container').append(crosshairY)

	timeline.to(crosshairX, {
		attr: {
			'y1': checkpointY,
			'y2': checkpointY
		},
		duration: animationDurationPart1
	}, 0)

	timeline.to(crosshairX, {
		attr: {
			'y1': endY,
			'y2': endY
		},
		duration: animationDurationPart2
	}, animationDurationPart1)

	timeline.to(crosshairY, {
		attr: {
			'x1': checkpointX,
			'x2': checkpointX
		},
		duration: animationDurationPart1
	}, 0)

	timeline.to(crosshairY, {
		attr: {
			'x1': endX,
			'x2': endX
		},
		duration: animationDurationPart2
	}, animationDurationPart1)
}


function animationRightToTop(animationSvg) {

	// durations for different animation parts
	const animationDurationPart1 = 17.5
	const animationDurationPart2 = 17.5
	const animationDurationTrail = 8.5
	const animationDelayTrail = 26
	
	// create the timeline for the animation
	const timeline = gsap.timeline({
		repeat: -1,
		defaults: {
			ease: 'linear'
		}
	})
	
	// the dot that will be animated
	const dot = $('circle.right-to-top-movement')

	// read the coordinates of the path (defined inside svg)
	const startX = dot.attr('cx')
	const startY = dot.attr('cy')
	const { checkpointX, checkpointY, endX, endY } = dot.data()

	// animate the dot towards the checkpoint
	timeline.to(dot[0], {
		attr: {
			'cx': checkpointX,
			'cy': checkpointY
		},
		duration: animationDurationPart1
	}, 0)

	// animate the dot towards the end coordinates
	timeline.to(dot[0], {
		attr: {
			'cx': endX,
			'cy': endY
		},
		duration: animationDurationPart2
	}, animationDurationPart1)
	
	// create the line svg element that will serve as the trail behind the moving dot
	let trail = document.createElementNS('http://www.w3.org/2000/svg', 'line')

	// at the start it doesn't exist, so its start and end coordinates can be same
	// stroke uses a different linear gradient because the line is vertical
	$(trail).attr({
		'x1': startX,
		'y1': startY,
		'x2': startX,
		'y2': startY,
		'stroke': 'url(#leftToRightTransparencyGrad)'
	})
	// append the line into a container before the dots in order for dots to have a higher z-index
	animationSvg.find('.lines-container').append(trail)

	// animate the start coordinates of the trail to follow the moving dot
	timeline.to(trail, {
		attr: {
			'x1': checkpointX,
			'y1': checkpointY
		},
		duration: animationDurationPart1
	}, 0)

	// animate the opacity of the first part of the tail
	timeline.to(trail, {
		opacity: 0,
		duration: animationDurationPart1
	}, animationDurationPart1 * 1.2)

	// create the second line that will serve as the trail after the checkpoint
	let trail2 = document.createElementNS('http://www.w3.org/2000/svg', 'line')

	// at the start it doesn't exist, so its start and end coordinates can be same
	// stroke uses a linear gradient for coloring, defined inside the svg
	$(trail2).attr({
		'x1': checkpointX,
		'y1': checkpointY,
		'x2': checkpointX,
		'y2': checkpointY,
		'stroke': 'url(#bottomToTopTransparencyGradAnimated)'
	})
	// append the line into a container before the dots in order for dots to have a higher z-index
	animationSvg.find('.lines-container').append(trail2)

	// animate the start coordinates of the second trail to follow the moving dot after the checkpoint
	timeline.to(trail2, {
		attr: {
			'x1': endX,
			'y1': endY
		},
		duration: animationDurationPart2
	}, animationDurationPart1)

	// animate the end coordinates of the first trail towards the checkpoint in order to start shrinking it
	timeline.to(trail, {
		attr: {
			'x2': checkpointX,
			'y2': checkpointY
		},
		duration: animationDurationTrail
	}, animationDelayTrail)

	// animate the gradient of the second trail
	timeline.from($('#bottomToTopTransparencyGradAnimated .animate')[0], {
		attr: {
			'offset': '100%'
		},
		duration: animationDurationPart2 / 2
	}, (animationDelayTrail + animationDurationTrail) * 0.97)

	// animate the end coordinates of the second trail towards the end after the first trail is gone
	timeline.to(trail2, {
		attr: {
			'x2': endX,
			'y2': endY
		},
		duration: animationDurationTrail
	}, animationDelayTrail + animationDurationTrail)

	/**
	 * Similar logic for creating and animating the crosshair
	 */
	let crosshairX = document.createElementNS('http://www.w3.org/2000/svg', 'line')
	let crosshairY = document.createElementNS('http://www.w3.org/2000/svg', 'line')

	$(crosshairX).attr({
		'x1': '-100%',
		'y1': startY,
		'x2': '200%',
		'y2': startY,
		'stroke': 'rgba(0,0,0,0.05)'
	})

	$(crosshairY).attr({
		'x1': startX,
		'y1': '-100%',
		'x2': startX,
		'y2': '200%',
		'stroke': 'rgba(0,0,0,0.05)'
	})

	animationSvg.find('.lines-container').prepend(crosshairX)
	animationSvg.find('.lines-container').append(crosshairY)

	timeline.to(crosshairX, {
		attr: {
			'y1': checkpointY,
			'y2': checkpointY
		},
		duration: animationDurationPart1
	}, 0)

	timeline.to(crosshairX, {
		attr: {
			'y1': endY,
			'y2': endY
		},
		duration: animationDurationPart2
	}, animationDurationPart1)

	timeline.to(crosshairY, {
		attr: {
			'x1': checkpointX,
			'x2': checkpointX
		},
		duration: animationDurationPart1
	}, 0)

	timeline.to(crosshairY, {
		attr: {
			'x1': endX,
			'x2': endX
		},
		duration: animationDurationPart2
	}, animationDurationPart1)
}